import { GroupMember, User, UserFull } from '@wellesley/openapi'

export const ConnectionsTabs = {
  first: 'first',
  second: 'second',
} as const

export type ConnectionsTabItem =
  (typeof ConnectionsTabs)[keyof typeof ConnectionsTabs]

export type Handlers = {
  onFollow?(): void
  onUnfollow?(): void
}

export type ConnectionTab = {
  label: string
  counter: number
}

export type TabItem = 'first' | 'second'

export type InfiniteScrollProps = {
  hasNextPage: boolean
  onLoadMore: () => Promise<void>
}

export type ConnectionModalProps = Handlers & {
  isOpen: boolean
  isLoading: boolean
  searchQuery: string
  activeTab: ConnectionsTabItem
  onTabChange: (tab: ConnectionsTabItem) => void
  tabs?: Record<TabItem, ConnectionTab>
  user?: UserFull
  title?: string
  firstList?: User[] | GroupMember[]
  secondList?: User[] | GroupMember[]
  showLists?: boolean
  listClassName?: string
  dialogClassName?: string
  hiddenListMessage?: string
  onClose: () => void
  onSearchQueryChange: (query: string) => void
  renderFooter?: () => JSX.Element | null
  firstListInfiniteScroll?: InfiniteScrollProps
  secondListInfiniteScroll?: InfiniteScrollProps
}
